import { cloneDeep, get, pick } from 'lodash'

import { Colors } from '@sigma-frontend-libs/commons'

import { icons, request } from '@/utils'

export const providersStates = {
  active: {
    color: Colors.success,
    icon: icons.check_circle_outline
  },
  inactive: {
    color: Colors.grey,
    icon: icons.pause_circle_outline
  },
  connecting: {
    color: Colors.primary,
    icon: icons.sync
  },
  disconnecting: {
    color: Colors.error,
    icon: icons.highlight_off
  },
  stopped: {
    color: Colors.warning,
    icon: icons.do_not_disturb_on
  },
  'half-open': {
    color: Colors.info,
    icon: icons.access_time
  },
  'error-code': {
    color: Colors.error,
    icon: icons.error_outline
  },
  'error-connection': {
    color: Colors.error,
    icon: icons.error_outline
  }
}

export const commonProperties = [
  'title',
  'comment',
  'properties',
  'replacements',
  'ServerId',
  'CredentialsId'
]

export const cloneProvider = async provider => {
  let { title, comment, properties, replacements, Server, ServerId, Credentials, CredentialsId } = pick(cloneDeep(provider), [ 'Server', 'Credentials', ...commonProperties ])

  const regex = /\((\d+)\)$/
  const match = title.match(regex)
  if (match) {
    const index = parseInt(match[1])
    title = title.replace(regex, `(${index + 1})`)
  } else {
    title = `${title} (1)`
  }

  if (!ServerId) {
    ServerId = get(Server, 'id')
  }
  if (!CredentialsId) {
    CredentialsId = get(Credentials, 'id')
  }

  return await request.create('providers', {
    body: {
      title,
      comment,
      properties,
      replacements,
      ServerId,
      CredentialsId,
      isActive: true
    }
  })
}
